/**
 * @fileoverview Subscription Utilities - GameState購読ユーティリティ
 */

/**
 * パス境界を正確にチェックする関数
 * startsWithの境界バグを回避
 *
 * @param {string} path - チェック対象のパス
 * @param {string} base - ベースパス
 * @returns {boolean} パスがベース配下にあるかどうか
 *
 * @example
 * isUnderPath('core.status', 'core.status') // true
 * isUnderPath('core.status.title', 'core.status') // true
 * isUnderPath('core.statusName', 'core.status') // false
 */
export function isUnderPath(path, base) {
  return path === base || path.startsWith(`${base}.`);
}

/**
 * GameStateの変更から対象パスだけを拾ってhandlerを呼ぶ薄い共通化
 * 複数パス対応、初回更新の有無、unsubscribeを一括で扱う
 *
 * @param {GameState} gameState - GameStateインスタンス
 * @param {string|string[]} paths - 監視対象パス（配列可）
 * @param {() => void} handler - 変化時に呼ぶ処理
 * @param {boolean} runOnceOnInit - 初回即時実行するか
 * @returns {() => void} unsubscribe関数
 *
 * @example
 * // 単一パス監視
 * const unsub = onPathChange(gameState, 'core.status', () => {
 *   updateResultDisplay(gameState);
 * });
 *
 * // 複数パス監視
 * const unsub = onPathChange(gameState, ['core.status', 'ui.isSkillTargeting'], () => {
 *   updateAllButtons(gameState);
 * });
 */
export function onPathChange(gameState, paths, handler, runOnceOnInit = true) {
  const pathList = Array.isArray(paths) ? paths : [paths];

  // パス判定関数（境界バグ回避版）
  const shouldTrigger = (path) => pathList.some((base) => isUnderPath(path, base));

  // GameStateの変更を監視
  const unsubscribe = gameState.subscribe((event) => {
    if (typeof event === 'function') {
      return;
    }

    if (event == null) {
      handler();
      return;
    }

    const path =
      typeof event === 'string'
        ? event
        : event && typeof event === 'object'
          ? event.path
          : undefined;

    if (typeof path !== 'string' || path.length === 0) {
      handler();
      return;
    }

    if (shouldTrigger(path)) {
      handler();
    }
  });

  // 初回実行（オプション）
  if (runOnceOnInit) {
    handler();
  }

  return unsubscribe;
}
